// plugins/parse-accordion-content.js
import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("parseAccordionContent", (htmlContent) => {
    if (typeof window !== "undefined") {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Préparer la structure de retour pour les accordéons et le contenu non-accordéon
      const accordions = [];
      let nonAccordionContent = "";

      doc.body.childNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.getAttribute("data-accordion") === "title"
        ) {
          const title = node.innerHTML;
          const contentEl = node.nextElementSibling;

          // Vérifie si c'est bien un contenu d'accordéon
          if (
            contentEl &&
            contentEl.getAttribute("data-accordion") === "content"
          ) {
            accordions.push({
              title,
              content: contentEl.innerHTML,
            });
          }
        } else {
          nonAccordionContent += node.outerHTML || node.textContent;
        }
      });

      return {
        accordions,
        nonAccordionContent,
      };
    } else {
      return { accordions: [], nonAccordionContent: "" };
    }
  });
});

// plugins/parse-accordion-content.js
/*export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("parseAccordionContent", (htmlContent) => {
    return (
      useClientOnly(() => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");
        const accordions = [];

        doc.querySelectorAll(".accordion-title").forEach((titleEl) => {
          const contentEl = titleEl.nextElementSibling;
          if (contentEl && contentEl.classList.contains("accordion-content")) {
            accordions.push({
              title: titleEl.innerHTML,
              content: contentEl.innerHTML,
            });
          }
        });

        return accordions;
      }) || []
    ); // Retourne un tableau vide côté serveur pour éviter les erreurs
  });
});
*/
